import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  display: inline-flex;\n  vertical-align: text-bottom;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  width: 50%;\n  padding-right: ", ";\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  width: ", ";\n  height: ", ";\n  padding-bottom: ", ";\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex: 1;\n  flex-direction: ", ";\n  height: ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  margin: 0;\n  outline: none;\n  &::after {\n    color: ", ";\n    content: ' Optional';\n    display: inline;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: inline-flex;\n  margin-bottom: ", ";\n  width: ", ";\n  > * {\n    white-space: ", ";\n    text-overflow: ", ";\n    overflow: ", ";\n  }\n  p {\n    line-height: ", ";\n  }\n\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { calculateRem } from '@uie/javascript-style-helpers';
import { Body, Micro, MicroConfig, TypographyConfig } from '@vds-core/typography';
import { colors, calculateSpacing } from '@vds-core/theme';
import { withVDSManager } from '@vds-core/utilities';
var propTypes = {
  /**
   * If provided, will provide the id of the input the label focuses to onClick
   */
  htmlFor: PropTypes.string,

  /**
   * @ignore
   */
  disabled: PropTypes.bool,

  /**
   * If provided, will provide the context for the 'label' on the input field.
   */
  label: PropTypes.string,

  /**
   * When true, will add the required attribute to the input element, if false, a string of 'Optional' next to the label
   */
  required: PropTypes.bool,

  /**
   * @ignore - config for passing through other colors
   */
  color: PropTypes.object,

  /**
   * @ignore - passes through typescale via sting if there's more than one option [example 'VDS' instead of 'MVP']
   */
  typescale: PropTypes.string,

  /**
   * @ignore - spacing between the label and the input field
   */
  labelMarginBottom: PropTypes.string,

  /**
   * @ignore - defines whether text trancates with ellipsis or not
   */
  overflowEllipsis: PropTypes.bool,

  /**
   * @ignore string representing the type of input
   */
  type: PropTypes.string,

  /**
   * @ignore If passed, new Body component will render
   */
  Body: PropTypes.func,

  /**
   * @ignore If passed, new Micro component will render
   */
  Micro: PropTypes.func,

  /**
   * @ignore If passed, the Tooltip will render
   */
  Tooltip: PropTypes.func,

  /**
   * String, array or node containing the title of the TooltipDialog
   */
  tooltipTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.node]),

  /**
   * String, array or node containing the body content of the TooltipDialog
   */
  tooltipContent: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.node])
};
var defaultProps = {
  disabled: false,
  label: undefined,
  required: true,
  color: colors,
  typescale: TypographyConfig.getTypescale(),
  labelMarginBottom: calculateRem(1),
  overflowEllipsis: false,
  Body: Body,
  Micro: Micro,
  type: undefined,
  Tooltip: undefined,
  tooltipTitle: undefined,
  tooltipContent: undefined
};
/* Line height of p tag is 15px but because it contains a tooltip it maintains the 16px line height.*/

var LabelWrapper = /*#__PURE__*/styled.label.withConfig({
  displayName: "LabelWrapper",
  componentId: "sc-1rik9md-0"
})(_templateObject(), function (_ref) {
  var labelMarginBottom = _ref.labelMarginBottom,
      label = _ref.label;
  return label ? labelMarginBottom : 0;
}, function (_ref2) {
  var helperText = _ref2.helperText,
      helperTextPlacement = _ref2.helperTextPlacement;
  return helperText && helperTextPlacement === 'right' ? '50%' : '100%';
}, function (_ref3) {
  var overflowEllipsis = _ref3.overflowEllipsis;
  return overflowEllipsis ? 'normal' : 'nowrap';
}, function (_ref4) {
  var overflowEllipsis = _ref4.overflowEllipsis;
  return overflowEllipsis ? null : 'ellipsis';
}, function (_ref5) {
  var overflowEllipsis = _ref5.overflowEllipsis;
  return overflowEllipsis ? null : 'hidden';
}, function (_ref6) {
  var hasTooltip = _ref6.hasTooltip;
  return hasTooltip ? calculateRem(15) : calculateRem(16);
}, function (_ref7) {
  var focusState = _ref7.focusState;
  return focusState && "\n    &:focus,\n    &:active {\n      outline: none;\n    }\n  ";
});
var OptionalLabel = /*#__PURE__*/styled.span.withConfig({
  displayName: "OptionalLabel",
  componentId: "sc-1rik9md-1"
})(_templateObject2(), function (_ref8) {
  var color = _ref8.color,
      disabled = _ref8.disabled;
  return disabled ? color.coolGray3 : color.coolGray6;
});
var CVVTooltipWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "CVVTooltipWrapper",
  componentId: "sc-1rik9md-2"
})(_templateObject3(), function (_ref9) {
  var cardType = _ref9.cardType;
  return cardType === 'other' ? 'row' : 'column';
}, function (_ref10) {
  var cardType = _ref10.cardType;
  return cardType === 'other' ? '160px' : cardType === 'amex' ? '110px' : '124px';
});
var CVVIconWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "CVVIconWrapper",
  componentId: "sc-1rik9md-3"
})(_templateObject4(), calculateRem(96), calculateRem(71), calculateSpacing('2X'));
var ColumnWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "ColumnWrapper",
  componentId: "sc-1rik9md-4"
})(_templateObject5(), function (_ref11) {
  var secondCol = _ref11.secondCol;
  return secondCol ? 0 : calculateSpacing('2X');
});
var AlignTooltip = /*#__PURE__*/styled.span.withConfig({
  displayName: "AlignTooltip",
  componentId: "sc-1rik9md-5"
})(_templateObject6());

var Label = function Label(props) {
  var typescale = props.typescale,
      Body = props.Body,
      Micro = props.Micro,
      id = props.id,
      width = props.width,
      disabled = props.disabled,
      color = props.color,
      required = props.required,
      label = props.label,
      Tooltip = props.Tooltip,
      tooltipTitle = props.tooltipTitle,
      tooltipContent = props.tooltipContent,
      type = props.type,
      labelMarginBottom = props.labelMarginBottom,
      helperText = props.helperText,
      helperTextPlacement = props.helperTextPlacement,
      overflowEllipsis = props.overflowEllipsis,
      focusState = props.focusState,
      htmlFor = props.htmlFor;

  function _renderSecurityCodeTooltip() {
    var cardType = props.cardType,
        CreditCardIcon = props.CreditCardIcon,
        Body = props.Body;
    var num = cardType === 'amex' ? '4' : '3';
    var name = cardType === 'amex' ? 'securityCodeAmex' : 'securityCode';
    var ending = cardType === 'amex' ? 'front of your credit card.' : 'back of your credit or debit card.';

    if (cardType !== 'other') {
      return /*#__PURE__*/React.createElement(CVVTooltipWrapper, {
        cardType: cardType
      }, /*#__PURE__*/React.createElement(CVVIconWrapper, null, /*#__PURE__*/React.createElement(CreditCardIcon, {
        name: name
      })), /*#__PURE__*/React.createElement(Body, null, "The ".concat(num, "-digit code found on the ").concat(ending)));
    } else {
      return /*#__PURE__*/React.createElement(CVVTooltipWrapper, {
        cardType: cardType
      }, /*#__PURE__*/React.createElement(ColumnWrapper, null, /*#__PURE__*/React.createElement(CVVIconWrapper, null, /*#__PURE__*/React.createElement(CreditCardIcon, {
        name: "securityCode"
      })), /*#__PURE__*/React.createElement(Body, null, "Most credit or debit cards have a 3-digit security code on the back.")), /*#__PURE__*/React.createElement(ColumnWrapper, {
        secondCol: true
      }, /*#__PURE__*/React.createElement(CVVIconWrapper, null, /*#__PURE__*/React.createElement(CreditCardIcon, {
        name: "securityCodeAmex"
      })), /*#__PURE__*/React.createElement(Body, null, "American Express cards have a 4-digit code located on the front.")));
    }
  }

  function _labelOnClick(e) {
    if (e.target.id !== props.id) {
      e.preventDefault();
    }
  }

  var hasTooltip = tooltipTitle || tooltipContent || type === 'securityCode';
  var LabelText = typescale === 'VDS' ? Body : Micro;
  return /*#__PURE__*/React.createElement(LabelWrapper, {
    "data-testid": "test-label",
    id: id,
    width: width,
    focusState: focusState,
    labelMarginBottom: labelMarginBottom,
    label: label,
    overflowEllipsis: overflowEllipsis,
    helperTextPlacement: helperTextPlacement,
    helperText: helperText,
    onClick: _labelOnClick,
    htmlFor: htmlFor,
    hasTooltip: tooltipTitle || tooltipContent
  }, /*#__PURE__*/React.createElement(LabelText, {
    id: id,
    typescale: typescale,
    disabled: disabled,
    primitive: 'p',
    color: disabled ? color.coolGray3 : typescale === 'VDS' ? color.black : color.coolGray6
  }, label, !required && /*#__PURE__*/React.createElement(OptionalLabel, {
    id: id,
    disabled: disabled,
    "aria-label": label,
    color: color,
    required: required
  }), hasTooltip && /*#__PURE__*/React.createElement(AlignTooltip, null, /*#__PURE__*/React.createElement(Tooltip, {
    size: "small",
    disabled: disabled,
    title: type === 'securityCode' ? null : tooltipTitle
  }, type === 'securityCode' ? _renderSecurityCodeTooltip() : tooltipContent))));
};

Label.defaultProps = defaultProps;
Label.propTypes = propTypes;
export default withVDSManager(Label);